import React, { useContext } from "react";
import { Col, Row } from "antd";

import { UnspecifiedResidentSection_fields } from "./fields-object/fields-object";
import { OvernighGuestContext } from "./context-view";
import { overnightGuestInitalValues as initialValues } from "./initialvalues/initialValues";

const Index = () => {
  let { pageData } = useContext(OvernighGuestContext);
  const data = pageData?.data || initialValues;

  return (
    <>
      <Row gutter={10} justify="space-between" align="center">
        {UnspecifiedResidentSection_fields.map((field) =>
          field.types.map((type, index) => (
            <Col key={index} span={11} className={"col-darken"}>
              {type.toUpperCase()}: {data[field.name][type]}
            </Col>
          ))
        )}
      </Row>
    </>
  );
};

export default Index;
